import type { TareProfileErrorCode, UnitProfileErrorCode } from '@crv/contracts';

export class UnitProfileDomainError extends Error {
  public readonly code: UnitProfileErrorCode;
  public readonly details?: unknown;

  constructor(code: UnitProfileErrorCode, message: string, details?: unknown) {
    super(message);
    this.name = 'UnitProfileDomainError';
    this.code = code;
    this.details = details;
  }
}

export class TareProfileDomainError extends Error {
  public readonly code: TareProfileErrorCode;
  public readonly details?: unknown;

  constructor(code: TareProfileErrorCode, message: string, details?: unknown) {
    super(message);
    this.name = 'TareProfileDomainError';
    this.code = code;
    this.details = details;
  }
}
